import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Editar perfil',
  subtitle:
    'O perfil aparece para os atletas ao lado dos eventos e das ofertas. Salvar não reabre a análise.',
  organization: 'Organização',
  contact: 'Contato e presença online',
  cancel: 'Cancelar',
  submit: 'Salvar perfil',
  saved: 'Perfil salvo',
  submitError: 'Não foi possível salvar o perfil. Tente de novo',
} satisfies TranslationTree;
